import './azores/style';
import FormStructure from './azores/form_structure';

export default FormStructure;